import { useContext, useState } from 'react'
import { AuthenticationContext } from '../../../../context/authenticationContext'

import { faSpinner } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { uploadToS3 } from '../../../../utils/S3Uploads'

const UploadFile = ({ returnURL, type }) => {
  const { user } = useContext(AuthenticationContext)
  const [loading, setLoading] = useState(false)

  const addFile = (file) => {
    setLoading(true)
    uploadFile(file)
  }

  const uploadFile = async (file) => {
    const fileURL = await uploadToS3({ file, user, type: type })
    returnURL(fileURL)
    setLoading(false)
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex">
        <input
          type="file"
          name="myAudio"
          onChange={(event) => {
            addFile(event.target.files[0])
          }}
          className="flex-1 input"
        />
        {loading && (
          <div className="flex items-center bg-green-500/20 border border-green-500 ml-2 p-3 rounded font-medium text-green-500 transition-all text-sm">
            <FontAwesomeIcon icon={faSpinner} spin />
          </div>
        )}
      </div>
    </div>
  )
}

export default UploadFile
